<template>
	<div id="app">
		<!-- <img src="./assets/logo.png"> -->
		<transition name="fade-transform" mode="out-in">
			<!-- <keep-alive> -->
			<router-view v-if="isRouterAlive" />
			<!-- </keep-alive> -->
		</transition>
		<!-- <router-view v-if="isRouterAlive" /> -->
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		// inject: ['reload'],
		name: 'App',
		watch: {
			$route(to, form) {
				if(to.path == '/homepage'){
					let body = document.getElementsByTagName('body')[0];
					// console.log("999",body);
					 // document.getElementsByTagName('body')[0].className = 'noslooce'; //直接替换的意思
					 //与上一个等价（此方法也可用来设置其他属性 如ID）
					 // document.getElementsByClassName('test')[1].setAttribute("class",'newClass') 
					 
					 //在原来的后面增加，注意要有空格
					 // document.getElementsByTagName('body')[0].className += ' snow-container'; 
			
				}else{
					// document.getElementsByTagName('body')[0].className = 'kongkong';
				}
				// this.reload();
				this.loadimg();
				// console.log("app----------------");
				var scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
				document.documentElement.scrollTop = document.body.scrollTop = 0;
			},
		},
		components: {

		},
		computed: {
			...mapState({
				pathIndex: state => state.order.pathIndex,
			})
		},
		mounted() {
			// console.log("app");
			// console.log('路径进来只是执行一次',this.pathIndex);
			
		},
		provide() {
			return {
				reload: this.reload,
			}
		},
		data() {
			return {
				isRouterAlive: true,
			}
		},
		methods: {
			loadimg() {
				const loading = this.$loading({
					lock: true,
					text: '加载中......',
					// spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)',
					customClass: 'mask'
				});
				setTimeout(() => {
					loading.close();
				}, 700);
			},
			reload() {
				this.isRouterAlive = false;
				this.$nextTick(function() {
					this.isRouterAlive = true;
				})
			}
		}
	}
</script>

<style>
	body,
	html {
		margin: 0;
		padding: 0;
		width: 100%;
		min-width: 1300px;
	}

	body {
		padding-right: 0px !important;
		overflow: hidden;
	}

	.noslooce {
		scrollbar-width: none;
		-ms-overflow-style: none;
	}

	.noslooce::-webkit-scrollbar {
		display: none;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		/* margin-top: 60px; */
	}

	/* 
	enter-active 定义进入过渡的结束状态
	leave-active 定义离开过渡的结束状态
	 */
	.fade-transform-leave-active,
	.fade-transform-enter-active {
		transition: all 0.5s;
	}

	/* 
	enter定义进入过渡的开始状态
	 */
	.fade-transform-enter {
		opacity: 0;
		transform: translateX(-30px);
	}

	/* 
	leave-to离场动画结束后的状态
	 */
	.fade-transform-leave-to {
		opacity: 0;
		transform: translateX(30px);
	}

	.el-loading-spinner .el-loading-text {
		color: #FFFFFF !important;
		font-size: 16px !important;
	}

	/* .mask .el-loading-spinner i{color: #FFFFFF !important;font-size: 18px !important;} */
	.el-loading-spinner .path {
		stroke: #FFFFFF !important;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue